import axios from 'axios';
import qs from 'qs';
import { isLocalhost } from 'utils/networkUtils';
import Config from 'utils/getEnvConfig';

const { ENV, WRAPPED_SERVICE } = Config;
const API_URL = WRAPPED_SERVICE?.API_URL;
const API_KEY = WRAPPED_SERVICE?.API_KEY;

export const getUserSummary = async firebaseId => {
  try {
    const isDev = isLocalhost || ENV === 'development';
    let distinctId = firebaseId;

    if (isDev && typeof window !== 'undefined') {
      const queryParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });
      if (queryParams.distinct_id) {
        distinctId = queryParams.distinct_id;
        console.log(`[DEV] Using distinct_id from query param: ${distinctId}`);
      }
    }

    const response = await axios.post(
      API_URL,
      {
        distinct_ids: distinctId,
        generate_ai_summary: true,
        generate_recommendations: true,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': API_KEY,
        },
      },
    );

    const userData = response.data?.users?.[0];

    if (userData?.error) {
      return { error: true, message: userData.error };
    }

    return userData;
  } catch (error) {
    console.error('Error fetching user summary:', error);
    return {
      error: true,
      message: error.message || 'Failed to fetch user summary',
    };
  }
};
